<template>
  <section class="w-full">
    <div
      v-if="accom.coordinates.accuracy !== 'EXACT' && !isOpen"
      class="flex justify-between text-base font-light"
    >
      <p class="pb-2">{{ $t(`${trPrefix}accuracyHint`) }}</p>
    </div>

    <figure class="h-96 overflow-hidden relative rounded shadow">
      <template v-if="isOpen">
        <NuxtImg
          src="map/map-placeholder.svg"
          placeholder
          class="w-full h-full rounded-lg object-cover bg-[#e8eedb]"
        />

        <figcaption
          v-if="isOpen"
          class="absolute bottom-4 flex h-full w-full flex-col items-center justify-center gap-4 md:bottom-auto md:top-1/2 md:-translate-y-1/2"
        >
          <p class="w-64 text-xl font-light text-txt">
            {{ $t(`${trPrefix}activation`) }}
          </p>

          <WebccButton size="md" variant="theme" @click="toggle()">
            <span>{{ $t(`${trPrefix}activate`) }}</span>
          </WebccButton>
        </figcaption>
      </template>

      <RedesignMap v-else :accom class="relative h-full w-full" />
    </figure>

    <p
      class="inline-flex flex-wrap items-center space-x-1 py-2 text-base font-light text-txt"
    >
      <WebccIcon
        name="detailpage/pin"
        class="mr-1 h-4 w-4 fill-current stroke-current"
        filled
      />
      <WebccLink v-for="item in links" :key="item.slug" :to="item.slug">
        {{ item.name }}
      </WebccLink>
    </p>
  </section>
</template>

<script setup lang="ts">
const trPrefix = 'www.components.views.details.Map.'

const props = defineProps<{
  accom: TranslatedAccommodation
}>()

const [isOpen, toggle] = useToggle(true)
const tracking = useTracking()

const links = computed(() =>
  [
    props.accom.country,
    props.accom.region.main,
    props.accom.region,
    props.accom.place.main,
    props.accom.place,
  ]
    .filter(Boolean)
    .map((item, index, items) => ({
      ...item!,
      name: index === items.length - 1 ? item!.name : `${item!.name}, `,
    })),
)

watch(isOpen, (value) => !value && tracking.handlers?.search.mapView(true))
</script>
